import { apiURL } from 'config/baseURL';
import API from 'helpers/api';
import {
	CustomGroupPaginatedResponse,
	CustomGroupResponse,
} from 'reducers/lms/customGroupManagement/customGroupList/type';
import { IAPIResponse } from 'types/api';

export interface CreateCustomGroupRequest {
	customGroupName: string;
	description: string;
	userGroupIDs?: string[];
	userIDs?: string[];
}

export interface UpdateCustomGroupRequest {
	customGroupName?: string;
	description?: string;
	userGroupIDs?: string[];
	userIDs?: string[];
}

export interface CustomGroupParams {
	customGroupID: string;
}

export interface CustomGroupByIDResponse {
	docs: CustomGroupResponse[];
}

export interface CustomGroupDeleteResponse {
	deleted_at: string;
	customGroupID: string;
}

export const fetchCustomGroups = async (searchParams: string): Promise<CustomGroupPaginatedResponse> => {
	const url = `${apiURL}/lms/custom-groups/paginate?${searchParams}`;
	const token = await API.getFirebaseToken();
	const res = await API.getJSON<IAPIResponse<CustomGroupPaginatedResponse>>(url, token);

	return res?.data || { docs: [] };
};

export const fetchCustomGroupById = async (customGroupID: string): Promise<CustomGroupResponse | null> => {
	const url = `${apiURL}/lms/custom-groups/${customGroupID}`;
	const token = await API.getFirebaseToken();
	const res = await API.getJSON<IAPIResponse<CustomGroupByIDResponse>>(url, token);

	return res?.data?.docs?.[0] || null;
};

export const createCustomGroup = async (payload: CreateCustomGroupRequest): Promise<CustomGroupResponse | null> => {
	const url = `${apiURL}/lms/custom-groups`;
	const token = await API.getFirebaseToken();
	const res = await API.postJSON<IAPIResponse<CustomGroupResponse>>(url, payload, token);

	return res?.data || null;
};

export const updateCustomGroup = async (
	customGroupID: string,
	payload: UpdateCustomGroupRequest,
): Promise<CustomGroupResponse | null> => {
	const url = `${apiURL}/lms/custom-groups/update/${customGroupID}`;
	const token = await API.getFirebaseToken();
	const res = await API.patchJSON<IAPIResponse<CustomGroupResponse>>(url, payload, token);

	return res?.data || null;
};

export const deleteCustomGroup = async (customGroupID: string): Promise<CustomGroupDeleteResponse | null> => {
	const url = `${apiURL}/lms/custom-groups/${customGroupID}`;
	const token = await API.getFirebaseToken();
	const res = await API.deleteJSON<IAPIResponse<CustomGroupDeleteResponse>>(url);

	return res?.data || null;
};
